module.exports = __webpack_public_path__ + "img/invoices.c7a91bbf.png";